import { render, staticRenderFns } from "./NotificationSettingShow.vue?vue&type=template&id=18a91b5c&"
import script from "./NotificationSettingShow.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports